<h2 mat-dialog-title>Utwórz wydarzenie antenkowe</h2>

<mat-dialog-content>
	@if (submitLoader()) {
		<div class="w-100 h-100 d-flex justify-content-center align-items-center">
			<mat-spinner></mat-spinner>
		</div>
	} @else {
		<form [formGroup]="tourismEventForm" class="tourism-event-form">
			<app-generic-mat-autocomplete
				[apiUrl]="environment.erpSymfonyUrl + '/tourismEvents/search'"
				[apiSearchParam]="'omitHistoric=true&side=' + (data.side ?? 'D') + '&by'"
				[placeholder]="'Wyszukaj wydarzenia transportowe *'"
				[required]="true"
				[responseMapper]="erpEventsMapper"
				[idKey]="'id'"
				[displayKeys]="['newId', 'name']"
				[multiple]="true"
				(selectedMultiple)="onTourismEventsSelected($event)"
			>
			</app-generic-mat-autocomplete>
			<mat-form-field appearance="outline" class="w-100">
				<mat-label>Wyszukaj kierowców</mat-label>
				<input
					matInput
					formControlName="driverSearch"
					placeholder="Wpisz co najmniej 3 znaki..."
					[matAutocomplete]="driverAutocomplete"
				/>
				<mat-autocomplete #driverAutocomplete="matAutocomplete" [displayWith]="displayDriverName">
					@for (driver of driversList(); track driver.id) {
						<mat-option [value]="driver"> {{ displayDriverName(driver) }} </mat-option>
					}
					@if (
						driversList().length === 0 && tourismEventForm.get(FormControlName.DRIVER)?.value?.length >= 3
					) {
						<mat-error> Brak wyników </mat-error>
					}
				</mat-autocomplete>
			</mat-form-field>
		</form>
	}
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-button (click)="onCancel()">Anuluj</button>
	<button
		mat-raised-button
		color="primary"
		(click)="onSubmit()"
		[disabled]="tourismEventForm.invalid || submitLoader()"
	>
		Utwórz wydarzenie
	</button>
</mat-dialog-actions>
